import { useFileUpload } from "helpers/useFileUpload";
import React from "react";

import { IconButton } from "./iconButton";

function Attachment({
  attachment,
  onClickRemove,
  isUploading,
}: {
  attachment: Upload;
  onClickRemove: () => void;
  isUploading: boolean;
}) {
  return (
    <div className="flex items-center">
      <a href={`/api/upload/${attachment.filename}`} target="_blank" rel="noreferrer">
        {attachment.original_filename}
      </a>
      <IconButton icon="trash-alt" colour="danger" className="ml-2" onClick={onClickRemove} disabled={isUploading} />
    </div>
  );
}

interface FileUploadProps {
  multiple: boolean;
  attachments: Upload[];
  setAttachments: (attachments: Upload[]) => void;
  selectedEmployee: Employee | null | undefined;
}

export function FileUpload({ multiple, attachments, setAttachments, selectedEmployee }: FileUploadProps) {
  const { fileAsync, isUploading, error } = useFileUpload(selectedEmployee);

  async function handleUpload(event: React.ChangeEvent<HTMLInputElement>) {
    const uploads = await fileAsync(event);
    if (multiple) {
      setAttachments([...attachments, ...uploads]);
    } else {
      setAttachments(uploads);
    }
  }

  function removeAttachment(index?: number) {
    if (multiple && index !== undefined) {
      const att = attachments.filter((_: Upload, i: number) => i !== index);
      setAttachments(att);
    } else {
      setAttachments([]);
    }
  }
  function renderMultipleUploads() {
    return (
      <>
        {attachments.map((attachment: Upload, index: number) => (
          <Attachment
            key={`attachment-${index}`}
            attachment={attachment}
            onClickRemove={() => removeAttachment(index)}
            isUploading={isUploading}
          />
        ))}
        <input type="file" accept="image/*,.pdf" multiple onChange={handleUpload} disabled={isUploading} />
      </>
    );
  }

  function renderSingleUpload() {
    if (attachments.length > 0) {
      const attachment = attachments[0] as Upload;
      return <Attachment attachment={attachment} onClickRemove={() => removeAttachment()} isUploading={isUploading} />;
    } else {
      return <input type="file" accept="image/*,.pdf" onChange={handleUpload} disabled={isUploading} />;
    }
  }

  return (
    <div className="flex flex-col">
      {multiple ? renderMultipleUploads() : renderSingleUpload()}
      {isUploading && <p>Uploading...</p>}
      {error && <div className="text-danger">{error}</div>}
    </div>
  );
}
